/* GASSISA
=========================================================================================
* Descripción: 
* Historial de cambios:
* ---------------------------------------------------------------------------------------
*    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
* ---------------------------------------------------------------------------------------
*      1       | 17/09/2024 | Lic. José Luis Aragón Cervantes  | Creación
*      2       | 02/06/2026 | Lic. José Luis Aragón Cervantes  | Confirmación de eliminación de accesos
* --------------------------------------------------------------------------------------- */

import { Grid, Typography } from "@mui/material";

import SizeSoftXModal from "../../leyout/SizeSoftXModal";
import { useAccesos } from "../../../context/Catalogos/AccesosContext";

export default function AccesoEliminar() {
    const { 
      modalOpenEliminarAcceso,
      handleCloseEliminarAcceso,
      handleSubmitEliminarAcceso,
      usuarioActual,
    } = useAccesos();
  
    return (
      <SizeSoftXModal
        open={modalOpenEliminarAcceso}
        title={"Eliminar acceso"}
        onClose={handleCloseEliminarAcceso}
        onSuccess={handleSubmitEliminarAcceso}
        success="Eliminar"
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography>¿Desea eliminar el acceso seleccionado?</Typography>
            <Typography sx={{ mt: 1, fontWeight: 700 }}>
              {(usuarioActual?.usuario ?? "").trim()} - {(usuarioActual?.nombreusuario ?? "").trim()}
            </Typography>
          </Grid>
        </Grid>
      </SizeSoftXModal>
    );
  }
  
